<!-- 竖直列的数据 -->
<template>
  <div>
    <div class="img" v-for="(item,index) in listData" :key="index" @click="toPath(item)">
      <div class="img_top">
        <van-image class="img_pic" :src="utils.getFileUrl(Number(item.coverId))" />
        <div v-if="item.moduleTypeCode === 5 || item.moduleTypeCode === 6" class="img_word">{{item.courseStatus}}</div>
      </div>
      <div class="img_content">
        <div>{{item.dataName}}</div>
        <div>{{item.startTime ? item.startTime : item.gmtCreate}}</div>
        <div v-if="item.moduleTypeCode !=7">浏览量：{{item.viewVolume}}</div>
        <div v-if="item.moduleTypeCode !=5 && item.moduleTypeCode !=6">{{item.seriesName}}</div>
        <div v-else>{{item.seriesName}} | {{item.credit ? item.credit : 0}}分</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    listData: {
      type: Array
    }
  },
  data () {
    return {};
  },
  methods: {
    // 页面跳转
    toPath (data) {
      let path = ''
      let query = ''
      if (data.moduleTypeCode === 6) {
        path = '/md/dph'
        query = { dataId: data.id, moduleId: data.moduleId, moduleName: data.moduleName }
      } else if (data.moduleTypeCode === 3) { // 医学资料（文件上传）
        path = '/md/file'
        query = { dataId: data.id, moduleName: data.moduleName }
      } else if (data.moduleTypeCode === 2) { // 会议通知
        path = '/md/meet'
        query = { dataId: data.id, moduleId: data.moduleId, moduleName: data.moduleName }
      } else if (data.moduleTypeCode === 4) { // 视频点播
        path = '/md/video'
        query = { dataId: data.id, moduleId: data.moduleId, moduleName: data.moduleName }
      } else if (data.moduleTypeCode === 5) { // 视频直播（在线教育）
        path = '/md/live'
        query = { dataId: data.id, moduleId: data.moduleId, moduleName: data.moduleName }
      } else if (data.moduleTypeCode === 1) { // 文章撰写
        path = '/md/article'
        query = { dataId: data.id, moduleId: data.moduleId, moduleName: data.moduleName }
      } else if (data.moduleTypeCode === 7) { // 考试
        path = '/md/exam'
        query = { dataId: data.id, moduleId: data.moduleId, moduleName: data.moduleName }
      }
      this.$router.push({
        path: path,
        query: query
      })
    }
  },
  // 生命周期 - 创建完成（访问当前this实例）
  created () {},
  // 生命周期 - 挂载完成（访问DOM元素）
  mounted () {}
};
</script>
<style lang='scss' scoped>
/* @import url(); 引入css类 */
.img {
  width: 100%;
  padding: 20px;
  display: flex;
}
.img_top {
  position: relative;
}
.img_pic {
  width: 103px;
  height: 68px;
}
.img_word {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  color: #999999;
  height: 22px;
  font-family: PingFangSC-Medium;
  font-size: 10px;
  opacity: 0.66;
  background: #e5e5e5;
  border-radius: 2px;
}
.img_content {
  width: 100%;
  padding-left: 20px;
  div {
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #999999;
    letter-spacing: 0.1px;
    text-align: justify;
    font-weight: 400;
  }
}
.img_content :nth-child(1) {
  font-family: PingFangSC-Semibold;
  font-size: 16px;
  color: #333333;
  letter-spacing: 0.13px;
  font-weight: 600;
}
</style>
